import SupportSubpage from '../SupportSubpage/SupportSubpage';
import { ISubPageProps } from '../Support.types';
import getBreadcrumbsStaticProps from '../getBreadcrumbsStaticProps';

const StudySupport: React.FC<ISubPageProps> = (props) => {
  if (!props?.fields) return <></>;
  return <SupportSubpage {...props} formType="study-support-form" />;
};
export const getStaticProps = getBreadcrumbsStaticProps;
export default StudySupport;
